export const state = () => ({
  cart: {
    items: [],
    total: 0,
    msrpTotal: 0,
    subtotal: 0,
    discount: 0,
    loaded: false
  }
})

export const
  getters = {
    CART: state => state.cart,
    CART_LENGTH: state => state.cart.items.length > 999 ? '999+' : state.cart.items.length,
    CART_LOADED: state => state.cart.loaded
  }

export const actions = {
  async GET(vuexContext) {
    try {
      const data = await this.$axios.$get('cart')

      if (data?.items) {
        vuexContext.commit('SET', data)
        return Promise.resolve()
      } else {
        return Promise.reject('Cart getting server error')
      }
    } catch (err) {
      return Promise.reject('Cart getting server error')
    }
  },

  async ADD(vuexContext, { id, unit, quantity = 1, configurations = [], formatedConfigurations = [] }) {
    const payload = {
      id,
      unit,
      quantity,
      configurations,
      formatedConfigurations
    }

    try {
      const data = await this.$axios.$post(`cart`, payload)

      if (data?.result === false && data.message) {
        return Promise.reject({
          source: 'server',
          message: data.message
        })
      }

      if (data?.items) {
        vuexContext.commit('SET', data)
        this.$fbq?.('AddToCart', {
          content_ids: [String(id).trim()],
          content_type: 'product',
          contents: [{ id: String(id).trim(), quantity }]
        })
        return Promise.resolve(data)
      } else {
        return Promise.reject('Cart adding server error')
      }
    } catch (err) {
      return Promise.reject('Cart adding server error')
    }
  },

  async REMOVE(vuexContext, { id, objectId }) {
    try {
      const data = await this.$axios.$delete('cart', {
        data: {
          id,
          objectId
        }
      })

      if (data?.items) {
        vuexContext.commit('SET', data)
        return Promise.resolve()
      } else {
        return Promise.reject('Cart removing server error')
      }
    } catch (err) {
      return Promise.reject('Cart removing server error')
    }
  },

  async CHANGE(vuexContext, { id, objectId, quantity = 1, configurations = [], formatedConfigurations = [] }) {
    try {
      const data = await this.$axios.$patch('cart', {
        id,
        objectId,
        quantity,
        configurations,
        formatedConfigurations
      })

      if (data?.items) {
        vuexContext.commit('SET', data)
        return Promise.resolve(data)
      } else {
        return Promise.reject('Cart changing server error')
      }

    } catch (err) {
      return Promise.reject('Cart changing server error')
    }
  }
}

export const mutations = {
  SET(state, cart) {
    state.cart.items = cart.items
    state.cart.total = cart.total
    state.cart.msrpTotal = cart.msrpTotal
    state.cart.subtotal = cart.subtotal
    state.cart.discount = cart.discount
    state.cart.loaded = true
  },

  FORMAT_CONFIGURATIONS(state) {
    state.cart.items.forEach(product => {
      if (product.formatedConfigurations.length) {
        product.configurations = product.formatedConfigurations
      }
    })
  }
}